/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, HostListener, OnDestroy, VERSION } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { assetsConst } from '../../const/assets.const';
import { SideBarConst } from '../../const/sideBarConst';
import { TranslateService } from '@ngx-translate/core';
import { ModuleConst } from '../../const/moduleConst';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LoginResponse } from 'src/app/models/loginResponse';
import { userRole } from '../../const/userRole.const';
import { SideBar } from 'src/app/models/sideBar';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
  selector: 'megastore-admin-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnDestroy {
  assetsConst = assetsConst;
  sideBar = SideBarConst;
  userRole = userRole;
  moduleConst = ModuleConst;
  public innerWidth: string | number = 0;
  panelOpenState = false;
  version = VERSION;
  sidenavWidth = 15;
  ngStyle!: string;
  role = userRole.ADMIN;
  subscriptionSubject$: Subscription;
  destroy$: Subject<boolean> = new Subject<boolean>();
  // The collapsed rail sits on the right in Arabic, so its tooltips have to
  // open towards the content instead of off the edge of the screen.
  tooltipPosition: TooltipPosition = document.documentElement.dir === 'rtl' ? 'left' : 'right';
  constructor(
    public _authService: AuthService,
    public translateService: TranslateService
  ) {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.handleSideBar(res);
        }
      });
  }

  handleSideBar(res: LoginResponse): void {
    if (res.role === userRole.SUBADMIN) {
      this.subAdminRoleHandler(res);
    } else if (res.role === userRole.DISPATCHER) {
      this.role = userRole.DISPATCHER;
      this.dispatcherRoleHandler(res);
    } else {
      this.sideBar.forEach((el: SideBar) => {
        el.isView = el.isAdd = el.isEdit = el.isDelete = true;
        if(el.isSubMenu && el.subMenuItems && el.subMenuItems.length > 0){
          el.subMenuItems.forEach(subItem => {
            subItem.isView = subItem.isAdd = subItem.isEdit = subItem.isDelete = true;
          });
        }
      });
    }
  }

  subAdminRoleHandler(res: LoginResponse): void {
    const removeableItems = new Set([
      this.moduleConst.SubAdmin,
      // this.moduleConst.Dispatcher,
      // this.moduleConst.Vehicle,
      // this.moduleConst.Driver,
      // this.moduleConst.Teams,
      // this.moduleConst.Geofence,
      // this.moduleConst.Orders
    ]);
    this.sideBar = this.sideBar.filter(item => {
      if (removeableItems.has(item.sideBarId)) {
        return false;
      }
      const current = res?.accessRole?.permission?.find(
        el => el.sideBarId === item.sideBarId
      );
      if (current) {
        Object.assign(item, {
          isView: current.isView,
          isAdd: current.isAdd,
          isEdit: current.isEdit,
          isDelete: current.isDelete
        });
      }
      if(item.isSubMenu && item.subMenuItems && item.subMenuItems.length > 0){
        item.subMenuItems.forEach(subItem => {
          const current = res.accessRole?.permission?.find(
            el => el.sideBarId === subItem.sideBarId
          );
          if (current) {
            Object.assign(subItem, {
              isView: current.isView || false,
              isAdd: current.isAdd || false,
              isEdit: current.isEdit || false,
              isDelete: current.isDelete || false
            });
          }
        });
      }
      return true;
    });
  }

  dispatcherRoleHandler(res: LoginResponse): void {
    const addingItems = new Set([
      this.moduleConst.Dashboard,
      this.moduleConst.Logout,
      this.moduleConst.Vehicle,
      this.moduleConst.Teams,
      this.moduleConst.Driver,
      this.moduleConst.Geofence,
      this.moduleConst.Orders,
      601,
      602
    ]);
    this.sideBar = this.sideBar.filter(item => {
      if (addingItems.has(item.sideBarId)) {
        if(item.isSubMenu && item.subMenuItems && item.subMenuItems.length > 0){
          item.subMenuItems.forEach(subItem => {
            subItem.isView = subItem.isAdd = subItem.isEdit = subItem.isDelete = true;
          });
        }
        return true;
      }
      return false;
    });

    res.permission = this.sideBar;
  }

  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }
  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1200) {
      this._authService.toggle();
    }
  }
  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
    this.subscriptionSubject$.unsubscribe();
  }
}
